var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 20.2 20.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 12.5c-.1 0-.1 0-.1.1v2.6c0 .1 0 .1.1.1h1.3c.1 0 .1 0 .1-.1v-2.6c0-.1 0-.1-.1-.1H2.9zM5.6 11.1c-.1 0-.1 0-.1.1v4c0 .1 0 .1.1.1H7c.1 0 .1 0 .1-.1v-4c0-.1 0-.1-.1-.1H5.6zM13.8 5.5c-.1 0-.1 0-.1.1v2.1c.4-.1.7-.1 1.1-.1h.4v-2c0-.1 0-.1-.1-.1h-1.3zM8.3 9.8v2c.4-.8.9-1.5 1.5-2.1H8.4s-.1 0-.1.1zM14.8 9.5c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4c.1-3-2.4-5.4-5.4-5.4zm2.4 5.7s-.1.1 0 0l-1.9.1v1.8c0 .1 0 .1-.1.1h-.6c-.1 0-.1 0-.1-.1v-1.8h-1.8c-.1 0-.1 0-.1-.1v-.6c0-.1 0-.1.1-.1h1.8v-1.8c0-.1 0-.1.1-.1h.6c.1 0 .1 0 .1.1v1.8h1.8c.1 0 .1 0 .1.1v.6z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.5V7h9.4v1.8c.1-.1.2-.1.3-.2.1-.1.3-.2.4-.2.2-.1.5-.2.7-.3h.1V5.7c0-.1 0-.1-.1-.1H9.7V4.3H8.2v1.3H7v-4h9.5v6.3c.5.1 1 .3 1.5.5V.8c0-.4-.3-.8-.8-.8h-11c-.4 0-.8.3-.8.8v4.8H.8c-.4 0-.8.3-.8.8v11c0 .3.3.6.8.6h7.7c-.2-.5-.4-1-.5-1.5H1.5z",
    className: "st0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.a13b6b31.svg";
export { ForwardRef as ReactComponent };